import { render, staticRenderFns } from "./bigDataCharts3.vue?vue&type=template&id=64de7a64&"
import script from "./bigDataCharts3.vue?vue&type=script&lang=js&"
export * from "./bigDataCharts3.vue?vue&type=script&lang=js&"
import style0 from "./bigDataCharts3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports